import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowBack } from '@mui/icons-material';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600 flex items-center justify-center p-4">
      <div className="card bg-base-100 shadow-2xl max-w-2xl w-full">
        <div className="card-body items-center text-center p-12">
          {/* 404 Icon */}
          <div className="text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 mb-4">
            404
          </div>
          
          {/* Message */}
          <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
          <p className="text-lg text-base-content/70 mb-8 max-w-md">
            Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
          </p>

          {/* Logo */}
          <img 
            src="/images/logo.png" 
            alt="Core Loan Hub" 
            className="h-16 mb-8 opacity-50"
          />

          {/* Action Buttons */}
          <div className="card-actions gap-4">
            <button 
              className="btn btn-primary btn-lg gap-2"
              onClick={() => navigate('/dashboard')}
            >
              <Home className="w-5 h-5" />
              Go to Dashboard
            </button>
            <button 
              className="btn btn-outline btn-lg gap-2"
              onClick={() => navigate(-1)}
            >
              <ArrowBack className="w-5 h-5" />
              Go Back
            </button>
          </div>

          {/* Help Text */}
          <div className="mt-8 text-sm text-base-content/50">
            Need help? <a href="mailto:support@coreloanhub.com" className="link link-primary">Contact Support</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
